import { RecoilRoot } from "recoil";
import reportWebVitals from "./reportWebVitals";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.body as HTMLElement);

root.render(
  <RecoilRoot>
    <App />
  </RecoilRoot>
);

reportWebVitals();
